import {React,useState} from "react";
import { Link } from "react-router-dom";
import { phoneImg, questionImg } from "../../../asserts/images";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";


import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';

import "./style.css";

import { logo } from "../../../asserts/images";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";

import {partner1, partner2, partner3, partner4, partner5} from "../../../asserts/images";

// import React, { useState } from "react";




const Header = () => {

  const [showGhost, setShowGhost] = useState(false);
  const [showFiction, setShowFiction] = useState(false);
  const [showBooks, setShowBooks] = useState(false);
  const [showOther, setShowOther] = useState(false);
  const [showMore, setShowMore] = useState(false);
  

  return (
    <>
      <header className="position-relative">
        <div className="header_topbar sec_padding">
          {/* <div className="container-fluid">
            <div className="col-sm-12 col-lg-4 ml-auto">
              <div className="topbar_main_content justify-content-end">
                <div className="header_icon_with_info">
                  <Link className="header_topbar_icon">
                    <img
                      draggable={false}
                      src={phoneImg}
                      alt="phone"
                      className="img-fluid"
                    ></img>
                  </Link>
                  <Link>
                    <span className="header_topbar_info">13322826702</span>
                  </Link>
                </div>
                <div className="header_icon_with_info">
                  <Link className="header_topbar_icon">
                    <img
                      src={questionImg}
                      alt="phone"
                      className="img-fluid"
                    ></img>
                  </Link>
                  <Link>
                    <span className="header_topbar_info">Live Chat Now</span>
                  </Link>
                </div>
              </div>
            </div>
          </div> */}



            <nav className="navbar navbar-expand-lg bg-body-tertiary">
              <div className="container-fluid align-items-cennter">
                <ul className="topbar_number">
                  <li><a href="tel:(855) 408-6509" className="text-with-icon">
                  <FontAwesomeIcon icon={faPhone} style={{ color: '#fff' }} />
                    (855) 408-6509
                    </a></li>
                    <li><a href="mailto:info@falconbookwriting.com" className="text-with-icon">
                    <i class="fa-solid fa-envelope"></i>
                    info@falconbookwriting.com
                    </a></li>
                </ul>

                {/* <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon">
                    <div className="topbar_icon_custom-design">
                      <div className="topbar_icon_custom-design-lines"></div>
                      <div className="topbar_icon_custom-design-lines"></div>
                      <div className="topbar_icon_custom-design-lines"></div>
                    </div>
                  </span>
                </button> */}

                {/* <div className="collapse navbar-collapse" id="navbarSupportedContent">
                  <ul className="navbar-nav ml-auto mb-2 mb-lg-0">
                    <li className="nav-item">
                      <Link className="nav-link" to={"/"}>Home</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to={"/about-us"}>About</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to={"/featured-author"}>Featured Authors</Link>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="/blogs" >Blogs</a>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to={"/contact-us"}>Contact</Link>
                    </li>
                  </ul>
                </div> */}
              </div>
            </nav>   
        </div>

        

        <section className="header_navbar sec_padding">
          <div className="container-fluid">
            <Navbar expand="lg" className="">
              <Container fluid className="justify-content-between">
                <Navbar.Brand as={Link} to="/" className="header-logo">
                  <img src={logo} alt="" />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                  <Nav className="justify-content-end w-100 desktop-menu">

                    

                      {/* Ghost Book Writing Dropdown */}

                      <Dropdown id="dropdown-basic-button" className="navbar-more-btn navbar-Ghost-btn"
                        onMouseEnter={() => setShowGhost(true)}
                        onMouseLeave={() => setShowGhost(false)}
                        show={showGhost}
                      >
                        <Dropdown.Toggle as={Link} to="/ghost-writing" id="dropdown-basic-button">
                          Ghost Book Writing
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <div className="row">

                          <div className="col">
                            <Dropdown.Item><Link to={'/story-writing'}>Story Writing</Link></Dropdown.Item>
                            <Dropdown.Item><Link to={'/song-writing'}>Song Writing</Link></Dropdown.Item>
                            <Dropdown.Item><Link to={'/memoir-writing'}>Memoir Writing</Link></Dropdown.Item>
                            <Dropdown.Item><Link to={'/non-fiction-writing'}>Non-Fiction Writing</Link></Dropdown.Item>
                            <Dropdown.Item><Link to={'/rhyme-writing'}>Rhymes Writing</Link></Dropdown.Item>
                            <Dropdown.Item><Link to={'/book-writing-service'}>Book Writing</Link></Dropdown.Item>
                          </div>

                          <div className="col">
                            {/* <Dropdown.Item><Link to={'javascript:;'}>Biography Writing</Link></Dropdown.Item> */}
                            <Dropdown.Item><Link to={'/autobiography-writing'}>Autobiography</Link></Dropdown.Item>
                            <Dropdown.Item><Link to={'/seo-content-writing'}>SEO Content Writing</Link></Dropdown.Item>
                            <Dropdown.Item><Link to={'/hip-hop-writing'}>Hip Hop Writing</Link></Dropdown.Item>
                            <Dropdown.Item><Link to={'/script-writing'}>Script Writing</Link></Dropdown.Item>
                            <Dropdown.Item><Link to={'/narrative-writing'}>Narrative Writing</Link></Dropdown.Item>
                            <Dropdown.Item><Link to={'/article-writing-publication'}>Article Writing</Link></Dropdown.Item>
                          </div>

                          <div className="col">
                            <Dropdown.Item><Link to={'/novel-writing'}>Novel Writing</Link></Dropdown.Item>
                            <Dropdown.Item><Link to={'/wiki-writing'}>Wiki Writing</Link></Dropdown.Item>
                            <Dropdown.Item><Link to={'/speech-writing'}>Speech Writing</Link></Dropdown.Item>
                            <Dropdown.Item><Link to={'/comedy-writing'}>Comedy Writing</Link></Dropdown.Item>
                            <Dropdown.Item><Link to={'/movie-writing'}>Movie Writing</Link></Dropdown.Item>
                            <Dropdown.Item><Link to={'/screen-writing'}>Screen Writing</Link></Dropdown.Item>
                          </div>

                          <div className="col">
                            <Dropdown.Item><Link to={'/military-fiction-writing'}>Military Fiction Writing</Link></Dropdown.Item>
                            <Dropdown.Item><Link to={'/comic-writing'}>Comic Book Writing</Link></Dropdown.Item>
                            <Dropdown.Item><Link to={'/children-book-writing'}>Children’s Books</Link></Dropdown.Item>
                            <Dropdown.Item><Link to={'/ebook-writing'}>Ebook Writing</Link></Dropdown.Item>
                          </div>

                        </div>
                        </Dropdown.Menu>
                      </Dropdown>

                      {/* Fiction Writing Dropdown */}
                      <Dropdown id="dropdown-basic-button" className="navbar-more-btn navbar-fiction-btn"
                        onMouseEnter={() => setShowFiction(true)}
                        onMouseLeave={() => setShowFiction(false)}
                        show={showFiction}
                      >
                        <Dropdown.Toggle as={Link} to="/fiction-writing">
                          Fiction Writing
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item as={Link} to="/action-adventure-writing">Action Adventure Writing</Dropdown.Item>
                          <Dropdown.Item as={Link} to="/horror-writing">Horror Writing</Dropdown.Item>
                          {/* <Dropdown.Item as={Link} to="javascript:;">Fantasy Writing</Dropdown.Item>
                          <Dropdown.Item as={Link} to="javascript:;">Sci-Fi writing</Dropdown.Item> */}
                        </Dropdown.Menu>
                      </Dropdown>

                      {/* Book Editing Dropdown */}
                    
                      <Dropdown id="dropdown-basic-button" className="navbar-more-btn navbar-book-editing-btn"
                        onMouseEnter={() => setShowBooks(true)}
                        onMouseLeave={() => setShowBooks(false)}
                        show={showBooks}
                      >
                        <Dropdown.Toggle as={Link} to="/book-editing">
                          Book Editing
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item><Link to={'/book-formatting'}>Book Formatting</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/childrens-book-editors'}>Children's Book Editors</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/proof-reading'}>Book Proofreading</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/developmental-editing'}>Developmental Editing</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/sensitive-reading'}>Sensitive Reading</Link></Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>

                      {/* Other Services Dropdown */}
                    
                      <Dropdown id="dropdown-basic-button" className="navbar-more-btn navbar-other-btn"
                        onMouseEnter={() => setShowOther(true)}
                        onMouseLeave={() => setShowOther(false)}
                        show={showOther}
                      >
                        <Dropdown.Toggle as={Link} to="javascript:;">
                          Other Services
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item><Link to={'/book-cover-design'}>Book Cover Design</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/audio-book-design'}>Audio Book</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/book-video-trailer'}>Book Trailer</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/author-website'}>Author Website Design</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/book-publishing'}>Book Publishing</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/book-marketing'}>Book Marketing</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/children-book-printing'}>Children's Book Printing</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/book-illustration-services'}>Book Illustration Services</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/comic-book-illustration'}>Comic Book Illustration</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/childrens-book-and-illustrations'}>Children's Book Illustration</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/comic-book-translation'}>Comic Book Translation</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/arabic-book-translation'}>Arabic Book Translation</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/french-book-translation'}>French Book Translation</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/spanish-book-translation'}>Spanish Book Translation</Link></Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>

                      {/* More Services Dropdown */}
                    
                      <Dropdown id="dropdown-basic-button" className="navbar-more-btn"
                        onMouseEnter={() => setShowMore(true)}
                        onMouseLeave={() => setShowMore(false)}
                        show={showMore}
                      >
                        <Dropdown.Toggle as={Link} to="javascript:;">
                          More
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item><Link to={'/about-us'}>About</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/featured-author'}>Featured Authors</Link></Dropdown.Item>
                          <a className="bloglink" href="https://www.falconbookwriting.com/blogs/" >Blogs</a>
                          <Dropdown.Item><Link to={'/contact-us'}>Contact</Link></Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>                   
                    



                    {/* <Link as={Link} to="/book-publishing">
                      <p className="navbar_para">
                        Book{" "}
                        <span className="header_light_bold">Publishing</span>
                      </p>
                    </Link>

                    <Link to={"/ebook-writing"}>
                      <p className="navbar_para">
                        EBook{" "}
                        <span className="header_light_bold">Writing</span>
                      </p>
                    </Link>

                    <Link to={"/article-writing-publication"}>
                      <p className="navbar_para">
                      Article Writing &{" "}
                        <span className="header_light_bold">Publication</span>
                      </p>
                    </Link>

                    <Link to={"/book-marketing"}>
                      <p className="navbar_para">
                      Book <span className="header_light_bold">Marketing</span>
                      </p>
                    </Link>

                    <Link to={"/childrens-book-and-illustrations"}>
                      <p className="navbar_para">
                      Childrens Book <span className="header_light_bold">And Illustrations</span>
                      </p>
                    </Link> */}


                    

                    


                  </Nav>

                  <Nav className="justify-content-end w-100 mobile-menu">               
                    

                    <DropdownButton id="dropdown-basic-button" className="navbar-more-btn navbar-Ghost-btn" title="Ghost Book Writing">
                      <div className="row">

                        <div className="col">
                          <Dropdown.Item><Link to={'/ghost-writing'}>Ghost Writing</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/story-writing'}>Story Writing</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/song-writing'}>Song Writing</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/memoir-writing'}>Memoir Writing</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/non-fiction-writing'}>Non-Fiction Writing</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/rhyme-writing'}>Rhymes Writing</Link></Dropdown.Item>
                        </div>

                        <div className="col">
                          <Dropdown.Item><Link to={'/autobiography-writing'}>Autobiography</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/seo-content-writing'}>SEO Content Writing</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/hip-hop-writing'}>Hip Hop Writing</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/script-writing'}>Script Writing</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/narrative-writing'}>Narrative Writing</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/article-writing-publication'}>Article Writing</Link></Dropdown.Item>
                        </div>

                        <div className="col">
                          <Dropdown.Item><Link to={'/novel-writing'}>Novel Writing</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/wiki-writing'}>Wiki Writing</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/speech-writing'}>Speech Writing</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/comedy-writing'}>Comedy Writing</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/movie-writing'}>Movie Writing</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/screen-writing'}>Screen Writing</Link></Dropdown.Item>
                        </div>

                        <div className="col">
                          <Dropdown.Item><Link to={'/military-fiction-writing'}>Military Fiction Writing</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/comic-writing'}>Comic Book Writing</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/children-book-writing'}>Children’s Books</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/book-writing-service'}>Book Writing</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/ebook-writing'}>Ebook Writing</Link></Dropdown.Item>
                        </div>
                        

                      </div>
                    </DropdownButton>

                    <DropdownButton id="dropdown-basic-button" className="navbar-more-btn navbar-fiction-btn" title="Fiction Writing">
                      <div className="row">

                        <div className="col">
                          <Dropdown.Item><Link to={'/fiction-writing'}>Fiction Writing</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/story-writing'}>Action Adventure Writing</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/horror-writing'}>Horror Writing</Link></Dropdown.Item>
                        </div>

                      </div>
                    </DropdownButton>

                    <DropdownButton id="dropdown-basic-button" className="navbar-more-btn navbar-book-editing-btn" title="Books Editing">
                      <div className="row">

                        <div className="col">
                          <Dropdown.Item><Link to={'/book-editing'}>Book Editing</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/book-formatting'}>Book Formatting</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/childrens-book-editors'}>Children's Book Editors</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/proof-reading'}>Book Proofreading</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/developmental-editing'}>Developmental Editing</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/sensitive-reading'}>Sensitive Reading</Link></Dropdown.Item>
                        </div>

                      </div>
                    </DropdownButton>

                    <DropdownButton id="dropdown-basic-button" className="navbar-more-btn navbar-other-btn" title="Other Services">
                      <div className="row">

                        <div className="col">
                          <Dropdown.Item><Link to={'/book-cover-design'}>Book Cover Design</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/audio-book-design'}>Audio Book</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/book-video-trailer'}>Book Trailer</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/author-website'}>Author Website Design</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/book-publishing'}>Book Publishing</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/book-marketing'}>Book Marketing</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/children-book-printing'}>Children's Book Printing</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/book-illustration-services'}>Book Illustration Services</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/comic-book-illustration'}>Comic Book Illustration</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/childrens-book-and-illustrations'}>Children's Book Illustration</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/comic-book-translation'}>Comic Book Translation</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/arabic-book-translation'}>Arabic Book Translation</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/french-book-translation'}>French Book Translation</Link></Dropdown.Item>
                          <Dropdown.Item><Link to={'/spanish-book-translation'}>Spanish Book Translation</Link></Dropdown.Item>
                        </div>

                      </div>
                    </DropdownButton>

                    <DropdownButton id="dropdown-basic-button" className="navbar-more-btn" title="More">
                      <Dropdown.Item><Link to={'/about-us'}>About</Link></Dropdown.Item>
                      <Dropdown.Item><Link to={'/featured-author'}>Featured Authors</Link></Dropdown.Item>
                      <Dropdown.Item><Link to={'/blogs'}>Blogs</Link></Dropdown.Item>
                      <Dropdown.Item><Link to={'/contact-us'}>Contact</Link></Dropdown.Item>
                    </DropdownButton>


                    {/* <Link as={Link} to="/book-publishing">
                      <p className="navbar_para">
                        Book{" "}
                        <span className="header_light_bold">Publishing</span>
                      </p>
                    </Link>

                    <Link to={"/ebook-writing"}>
                      <p className="navbar_para">
                        EBook{" "}
                        <span className="header_light_bold">Writing</span>
                      </p>
                    </Link>

                    <Link to={"/article-writing-publication"}>
                      <p className="navbar_para">
                      Article Writing &{" "}
                        <span className="header_light_bold">Publication</span>
                      </p>
                    </Link>

                    <Link to={"/book-marketing"}>
                      <p className="navbar_para">
                      Book <span className="header_light_bold">Marketing</span>
                      </p>
                    </Link>

                    <Link to={"/childrens-book-and-illustrations"}>
                      <p className="navbar_para">
                      Childrens Book <span className="header_light_bold">And Illustrations</span>
                      </p>
                    </Link> */}


                    

                    


                  </Nav>

                </Navbar.Collapse>
              </Container>
            </Navbar>
          </div>
        </section>
      </header>


      <div className="float-badge">
        <div className="float-img">
          <span>Reviews</span>
          <img src={partner1} alt="" />
          <img src={partner2} alt="" />
          <img src={partner3} alt="" />
          <img src={partner4} alt="" />
          <img src={partner5} alt="" />
        </div>
      </div>
      



      <a href="tel:(855) 408-6509" class="whatsapp"><i class="fa fa-phone"></i></a>



    </>
  );
};








export default Header;
